var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invoiced-count"},[_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.value || 0))]),_c('span',{staticClass:"fill",style:(_vm.style)})])}
var staticRenderFns = []

export { render, staticRenderFns }